import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { post } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export interface AddTeamMembersSliceProp {
  orgName: string,
  memberEmails: string[],
}

export const addTeamMembers = createAsyncThunk(
  "add/team/members",
  async (params: AddTeamMembersSliceProp, storeActions) => {
    const url = `api/v1/user/add/team/members`;
    const response: any = await post(url, params, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const addTeamMembersSlice = createSlice({
  name: "addTeamMembers",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as number | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addTeamMembers.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(addTeamMembers.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(addTeamMembers.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = addTeamMembersSlice.actions;

export default addTeamMembersSlice;
